import React from 'react';
import PropTypes from 'prop-types';
import ShowPageWrapper from '../ShowPageWrapper';
import Comments from './Comments';

export default function StoryShowCommentsWrapper({ appData }) {
  const { storyId } = JSON.parse(appData);

  return (
    <ShowPageWrapper storyId={storyId}>
      <Comments />
    </ShowPageWrapper>
  );
}

StoryShowCommentsWrapper.propTypes = {
  appData: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/textEditor/StoryShowCommentsWrapper.jsx